export class MeetingDetails {
  globalId: string;
  graphId: string;
  uid: string;
  subject: string;
  showAs: string;
  comment: string;
  sensitivity: string;
  isCancelled: boolean;
  importance: string;
  categories: string[];
  isDecline: boolean;
  originalStart: string | null;
  allAttendees: any | null;
  apptSequenceNumber: number;
  isAllDay: boolean;
  sensorCustomData: any | null;
  lastUpdated: string;
  startWhole: string;
  endWhole: string;
  parentId: string;
  guid: string;
  sequenceNumber: number;
  version: number;
  isDeleted: boolean;
  body: any | null;
  startTime: {
    dateTime: string;
    timeZone: string;
  };
  endTime: {
    dateTime: string;
    timeZone: string;
  };
  responseStatus?: {
    responseType: string;
    time: string;
  };
  recurrence: any | null;
  organizer?: {
    emailAddress: {
      displayName: string;
      address: string;
    };
  };
  modifyInfo?: {
    createdDate: string;
    createdBy: any | null;
    lastModifiedDate: string;
    lastModifiedBy: any | null;
  };
  status?: string;
  timelineStatus?: string;
  externalProperty?: {
    subject: string;
    address: string;
  } | null;

  constructor(data: IMeetingDetails) {
    // Use 'any' for flexibility, refine if needed
    this.globalId = data.globalId || "";
    this.graphId = data.graphId || "";
    this.uid = data.uid || "";
    this.subject = data.subject || "";
    this.showAs = data.showAs || "";
    this.comment = data.comment || "";
    this.sensitivity = data.sensitivity || "";
    this.isCancelled = !!data.isCancelled;
    this.importance = data.importance || "";
    this.categories = data.categories || [];
    this.isDecline = !!data.isDecline;
    this.originalStart = data.originalStart || null;
    this.allAttendees = data.allAttendees || null;
    this.apptSequenceNumber = data.apptSequenceNumber || 0;
    this.isAllDay = !!data.isAllDay;
    this.sensorCustomData = data.sensorCustomData;
    this.lastUpdated = data.lastUpdated || "";
    this.startWhole = data.startWhole || "";
    this.endWhole = data.endWhole || "";
    this.parentId = data.parentId || "";
    this.guid = data.guid || "";
    this.sequenceNumber = data.sequenceNumber || 0;
    this.version = data.version || 0;
    this.isDeleted = !!data.isDeleted;
    this.body = data.body;
    this.startTime = data.startTime;
    this.endTime = data.endTime;
    this.responseStatus = data.responseStatus;
    this.recurrence = data.recurrence;
    this.organizer = data.organizer;
    this.modifyInfo = data.modifyInfo;
    this.status = data.status;
    this.timelineStatus = data.timelineStatus;
    this.externalProperty = data.externalProperty;
  }
}

export interface IMeetingDetails {
  globalId?: string;
  graphId?: string;
  uid?: string;
  subject?: string;
  showAs?: string;
  comment?: string;
  sensitivity?: string;
  isCancelled?: boolean;
  importance?: string;
  categories?: string[];
  isDecline?: boolean;
  originalStart?: string | null;
  allAttendees?: any | null;
  apptSequenceNumber?: number;
  isAllDay?: boolean;
  sensorCustomData?: any | null;
  lastUpdated?: string;
  startWhole?: string;
  endWhole?: string;
  parentId?: string;
  guid?: string;
  sequenceNumber?: number;
  version?: number;
  isDeleted?: boolean;
  body?: any | null;
  startTime: {
    dateTime: string;
    timeZone: string;
  };
  endTime: {
    dateTime: string;
    timeZone: string;
  };
  responseStatus?: {
    responseType: string;
    time: string;
  };
  recurrence?: any | null;
  organizer?: {
    emailAddress: {
      displayName: string;
      address: string;
    };
  };
  modifyInfo?: {
    createdDate: string;
    createdBy: any | null;
    lastModifiedDate: string;
    lastModifiedBy: any | null;
  };
  status?: string;
  timelineStatus?: string;
  externalProperty?: {
    subject: string;
    address: string;
  } | null;
}
